module.exports = __webpack_public_path__ + "static/media/1-01.d4d702e2.svg";